export const club = [
  {
    title: "Mi Club",
    path: "/dashboard",
    icon: "house",
  },
  {
    title: "Mis Equipos",
    path: "/teams-sumary",
    icon: "users-two",
  },
  {
    title: "Programación General",
    path: "/games-out",
    icon: "calendar",
  },
];

export const players = [
  {
    title: "Mis Jugadores",
    path: "/players-sumary",
    icon: "users",
  },
    {
      title : "Visualización de Abonos",
      path : "/payment",
      icon: "dollar",
    },
];

export const player = [
  {
    title: "Mi perfil",
    path: "/settings",
    icon: "user",
  },
   /*{
    title: "Información del jugador",
    path: "/player-profile",
  },*/
];

export const asistant = [
 {
    title: "Planilla",
    path: "/team-gear",
    icon: "text",
  },
       {
      title : "Abonos ",
      path : "/paymentreport",
      icon: "dollar",
    },
];

export const admin = [
 /* {
    title: "Clubs",
    path: "/all-clubs",
  }, */
  {
    title: "Equipos",
    path: "/all-teams",
    icon: "users-two",
  },
  {
    title: "Jugadores",
    path: "/all-players",
    icon: "users",
  },
  {
    title: "Programación General",
    path: "/games-out",
    icon: "calendar",
  },
    {
      title: "Gestionar partidos",
      path: "/games-management",
      icon: "sliders",
    },
    {
      title: "Administración de usuarios",
      path: "/all-users",
      icon: "gear-solid",
    },
    {
      title: "Grupos",
      path: "/groups",
      icon: "users-two",
    },
  {
      title : "Administración de Abonos y Pagos",
      path : "/paymentAdmin",
      icon: "dollar",
    },

    /*  {
      title : "Acumulado de amonestaciones",
      path : "/all-warning-count"
    } */
  ];

  export const referee = [
  ];

export const LINKS = [
  {
    title: "Opciones",
    icon: "table",
    pages: [],
  },
];

export const LINKS_old = [
  {
    title: "Opciones",
    icon: "table",
    pages: [
      {
        title: "Club summary",
        path: "/club-summary",
      },
      {
        title: "Game summary",
        path: "/game-summary",
      },
      {
        title: "Championships",
        path: "/championships",
      },
      {
        title: "League overview",
        path: "/league-overview",
      },
      {
        title: "Fans community",
        path: "/fans-community",
      },
      {
        title: "Statistics",
        path: "/statistics",
      },
      {
        title: "Error page",
        path: "/404",
      },
    ],
  },
  {
    title: "Matches",
    icon: "calendar",
    pages: [
      {
        title: "Match summary",
        path: "/match-summary",
      },
      {
        title: "Match overview",
        path: "/match-overview",
      },
    ],
  },
  {
    title: "Profile",
    icon: "users",
    pages: [
      {
        title: "Login",
        path: "/login",
      },
      {
        title: "Sign up",
        path: "/sign-up",
      },
      {
        title: "Player profile",
        path: "/player-profile",
      },
      {
        title: "Schedule",
        path: "/schedule",
      },
      {
        title: "Tickets",
        path: "/tickets",
      },
    ],
  },
  {
    title: "E-commerce",
    icon: "cart",
    pages: [
      {
        title: "Football store",
        path: "/football-store",
      },
      {
        title: "Brand store",
        path: "/brand-store",
      },
      {
        title: "Product details",
        path: "/product",
      },
    ],
  },
];
